export const formatDuration = (seconds: number): string => {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');

    return `${hours}h:${minutes}m`;
}